import MapView from '@arcgis/core/views/MapView';
import { MapPlugin } from '../arcgis-types';
import SketchEditor, {
  FetchEditorStateHandler, InitialValues, OnGeometryChangeHandler, Sketchable,
} from '../../../sketch-editor';
import { GeographicRecord } from '../../../sketch-editor/data-fetcher';
import { GeometricType } from '../../../types/geo';
import { setSupportedGeometryTypes } from '../../../sketch-editor/supported-geometry-types';

let sketchEditor: Sketchable;

/**
 * RecordSketchEditor pluggin will enable sketch editor within the mapview
 * It is responsible for initializing the sketch editor instance as well as
 * updating the sketch editor state.
 */
const RecordSketchEditor: (
  initialValues: InitialValues,
  fetchEditorState: FetchEditorStateHandler,
  fetchNearbyRecords: () => Promise<GeographicRecord[]>,
  onGeometryChange: OnGeometryChangeHandler,
  geometryTypes: GeometricType[],
  sketchable?: Sketchable,
) => MapPlugin = (initialValues, fetchEditorState, fetchNearbyRecords, onGeometryChange, geometryTypes, sketchable) => {
  sketchEditor = sketchEditor ?? sketchable ?? SketchEditor();

  return ({
    extendMap: (mapView: MapView) => {
      const {
        status, editable, loading, showValidationErrors, geometry, typeMismatched,
      } = fetchEditorState();

      setSupportedGeometryTypes(mapView, geometryTypes);

      sketchEditor.init(mapView, onGeometryChange, initialValues, geometryTypes, status);
      fetchNearbyRecords().then((nearbyRecords) => {
        sketchEditor.setNearbyRecords(nearbyRecords);
      });

      sketchEditor.setGeometryColor(status);
      sketchEditor.setEditingState({
        loading, showValidationErrors, editable, geometry, typeMismatched,
      });
    },
    onChange: (mapView: MapView) => {
      mapView.when(() => {
        const {
          status, editable, loading, showValidationErrors, geometry, typeMismatched,
        } = fetchEditorState();

        setSupportedGeometryTypes(mapView, geometryTypes);

        sketchEditor.setGeometryColor(status);
        sketchEditor.setEditingState({
          loading, showValidationErrors, editable, geometry, typeMismatched,
        });
      });
    },
  });
};

export default RecordSketchEditor;
